import DisplayModeDropdown from "./DisplayModeDropdown";
import { StepList } from "./StepList";
import { StepSearch } from "./StepSearch";
import { GoToFailure } from "./GoToFailure";

export default function Sidebar() {
  return (
    <div
      className="no-scrollbar absolute -left-2 -right-2 z-0 -mt-px flex h-full flex-col overflow-y-auto px-2"
      style={{ contain: "strict" }}
      data-testid="sidebar"
    >
      <div className="sticky top-0 z-10 flex flex-col gap-2 bg-white">
        <div className="mt-2 flex items-center gap-1.5">
          <StepSearch />
        </div>

        <div className="flex items-center gap-1.5 pb-0.5">
          <div className="flex-1">
            <DisplayModeDropdown />
          </div>
          <GoToFailure />
        </div>
      </div>

      <div className="flex flex-col gap-3 pt-1.5">
        <StepList />
      </div>
    </div>
  );
}
